//#region imports
import React, {useEffect, useState} from 'react';

// custom components
import { Text, Button, Footer, PageNavigator } from '../../components/atoms';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

// image
import CircleLogo from '../../assets/images/home/triple-image-together.png';
import ConnectProcess from '../../assets/images/home/connect-process.png';

// icons
import { SocialIcon } from 'react-social-icons';
import { IoMdArrowRoundForward } from 'react-icons/io';

// responsive page
import { useMediaQuery } from 'react-responsive'

//#endregion

//#region text
const whatisaprm = 'A person with reduced mobility (PRM) is one whose mobility is limited for the purposes of using a means of transportation due to any physical (sensory or  movement, permanent or temporary) or mental disability, due to age or to any other cause requiring special attention and adaptation to his/her needs of the services that are available to all passengers.';
const whatisprmassist = 'PRM Assist is an innovative and exciting aviation technology company based in Dublin, Ireland. Our founders identified many inefficiencies in the PRM assistance space and have dedicated the past two years developing solutions, utilizing the newest technologies to help airports, airlines and passengers.'
const whatisprmassist2 = 'Currently, our mobile application PRM Assist is available on iOS and android. The core purpose of the app is to allow passengers to create assistance bookings globally. Our web portal PRM Assist Portal is a data analytics tool that helps airport administrators handle their PRM bookings.'
const whatisprmconnect = 'PRM Connect is our API, which allows airlines to integrate their PRM Bookings with ours. By integrating your bookings with ours, airports and PRM service providers on both departure and arrival airports will be able to handle their bookings in a more efficent and percise manner. Increasing operational effeciencies, improving customer satisfaction and creating a more modern solution.'
const howtointegrate = 'This website documents how to integrate with our API. A Client ID and Client Secret are required to begin integration, if you have not contacted a PRM Assist representative please contact us to receive your credentials.'
//#endregion

const Introduction = (props) => {

    const [border, setBorder] = useState(false)

    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })

    return (
        <>
            {/* Introduction */}
            <Row>
                <Container className='mt-5' style={{borderWidth:border && 1, borderStyle: border && 'solid'}}>
                    <Text.Title>Getting Started</Text.Title>
                    <Text.Subtitle>Introduction</Text.Subtitle>
                    <Text.Text>Learn about PRM Assist and the problems we are solving.</Text.Text>
                </Container>
            </Row>

            {/* What is a PRM? & What is PRM Assist? & Image */}
            <Row className='mt-2'>
                <Col style={{ borderWidth: border && 1, borderStyle: border && 'solid' }}>
                    <Text.Headline>What is a PRM?</Text.Headline>
                    <Text.Text>{whatisaprm}</Text.Text>

                    <Text.Headline>What is PRM Assist?</Text.Headline>
                        <Text.Text>{whatisprmassist}</Text.Text>
                        <Text.Text>{whatisprmassist2}</Text.Text>
                </Col>
                { !isTabletOrMobile &&
                <Col style={{ borderWidth: border && 1, borderStyle: border && 'solid' }} className='mt-5'>
                    <img
                        src={ConnectProcess}
                        className="d-inline-block"
                        width={600}
                        style={{}}
                    />
                </Col>
                }
            </Row>

            {/* What is PRM Connect? & How do we Integrate? & Learn More Button */}
            <Row className='mt-2'>
                <Col style={{ borderWidth: border && 1, borderStyle: border && 'solid' }}>
                    <Text.Headline>What is PRM Connect?</Text.Headline>
                    <Text.Text>{whatisprmconnect}</Text.Text>
                    {/*<Button.CustomButton 
                        link={'/about'} 
                        variant={'outline-primary'}
                        icon={<IoMdArrowRoundForward size={16} color={'#307FE2'} style={{marginLeft:6, marginTop:-2}} />}    
                    >
                        Learn More
                    </Button.CustomButton>*/}
                        
                    <div className='mt-4'>
                        <Text.Headline>How do we integrate with PRM Connect?</Text.Headline>
                        <Text.Text>{howtointegrate}</Text.Text>
                        <Button.CustomButton 
                            link={'/getting-started'} 
                            variant={'outline-primary'}>
                            Get Started
                        </Button.CustomButton>
                    </div>
                </Col>
            </Row>
            
            {/* Community & Page Navigator */}
            <Row className='mt-5'>
                <Row>
                    <Col style={{ borderWidth: border && 1, borderStyle: border && 'solid' }}>
                        <Text.Headline>Our Community</Text.Headline>
                        <Text.Text>{'Join our community on Twitter, Discord and Github. Receive any updates on our API, announcements and cool trips. Also submit issues, get help and request features.'}</Text.Text>
                        <div style={{ display:'flex', justifyContent:'space-between', width:'20%' }}>
                            <SocialIcon url="https://twitter.com/PrmAssist" />
                            <SocialIcon url="https://discord.gg/sNBgbBvWYp" />
                        </div>

                        {/* Page Navigator */}
                        <PageNavigator leftText={'Home'} leftLink={'/'}  rightText={'Getting Started'} rightLink={'/getting-started'} />

                    </Col>
                </Row>
            </Row>

            {/* Footer */}
            <Footer small={true} />
        </>
    );
};

export default Introduction;
